import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "sidebar-section-preferences"
const DEFAULT_CLOSED_SECTIONS = ["grid-display"]

export default class extends Controller {
  static identifier = "sidebar-sections"
  static targets = ["toggle", "content"]

  connect() {
    this.state = this.loadState()
    this.toggleTargets.forEach((toggle) => {
      const section = this.sectionFor(toggle)
      if (!section) return
      const collapsed = this.state[section] ?? DEFAULT_CLOSED_SECTIONS.includes(section)
      this.applyState(section, collapsed, { store: false })
    })
  }

  toggle(event) {
    const toggle = event.currentTarget
    const section = this.sectionFor(toggle)
    if (!section) return

    const current = this.state[section] ?? false
    this.applyState(section, !current)
  }

  applyState(section, collapsed, { store = true } = {}) {
    this.state[section] = collapsed

    this.contentsFor(section).forEach((element) => {
      element.classList.toggle("hidden", collapsed)
    })

    const toggle = this.toggleFor(section)
    if (toggle) {
      toggle.setAttribute("aria-expanded", (!collapsed).toString())
      const indicator = toggle.querySelector("[data-section-indicator]")
      if (indicator) {
        indicator.textContent = collapsed ? "[+]" : "[-]"
      }
    }

    if (store) {
      this.persistState()
    }
  }

  contentsFor(section) {
    return this.contentTargets.filter((element) => element.dataset.section === section)
  }

  toggleFor(section) {
    return this.toggleTargets.find((element) => this.sectionFor(element) === section)
  }

  sectionFor(element) {
    return element?.dataset?.section
  }

  persistState() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state))
    } catch (_error) {
      // Ignore storage errors (e.g., private browsing or disabled storage)
    }
  }

  loadState() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      return raw ? JSON.parse(raw) : {}
    } catch (_error) {
      return {}
    }
  }
}
